var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.979 1.89954C25.1737 0.633788 23.9772 -0.365281 22.8581 0.128855L0.570026 9.9704C-0.232457 10.3248 -0.173754 11.5473 0.658542 11.8138L5.25483 13.286C6.13218 13.5669 7.08202 13.4216 7.84811 12.8893L18.2109 5.68904C18.5234 5.47187 18.864 5.91879 18.597 6.19552L11.1376 13.9301C10.414 14.6804 10.5576 15.9519 11.4281 16.5008L19.7797 21.7679C20.7164 22.3586 21.9214 21.7652 22.0965 20.6267L24.979 1.89954Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.0ae4cd4f038dcae9145625c44f6a37e1.svg";
export { ForwardRef as ReactComponent };